.controlsContainer {
    z-index: var(--mantine-priority-higher);
    gap: 0;
    width: 100%;
    background: var(--exwo-color-control-bar-bg);
    justify-content: center;
    align-items: center;
    padding: 0 var(--mantine-spacing-sm);
}

.controlsWrapper {
    gap: 12px;
    color: var(--mantine-color-gray-1);
    z-index: var(--mantine-priority-high);
    height: fit-content;
    justify-content: center;
    min-height: 3.23rem;
    width: 100%;
}

.noBottomLeftRadius {
    border-bottom-left-radius: 0;
}

.dropdownControlsWrapper {
    gap: 12px;
    position: relative;
    width: 100%;
}
